// node modules
import * as React from "react";
import { useHistory } from "react-router-dom";
import {
  Layout,
  Button,
  Avatar,
  Typography,
  Popover,
  Image,
  Badge,
  List,
} from "antd";
import { UserOutlined } from "@ant-design/icons";
// utils
import tokenService from "utils/tokenService";
// apis
import authApis from "apis/authApis";
// texts
// images
import notification from "assets/images/notification.svg";
import hard_drive from "assets/images/hard-drive.jpg";
// styles
import "styles/header.css";
import { useTranslation } from "react-i18next";

const { Header } = Layout;
const { Text, Title } = Typography;
const TokenService = tokenService.getService();
let NumberOfNotifs = 0;
let notifList = [];

const HeaderComponent = ({ userInfo, notifications }) => {
  /****************************************************** States **************************************************** */
  const history = useHistory();
  const [count, setCount] = React.useState(NumberOfNotifs);
  const [hideNotification, setHideNotification] = React.useState(false);
  const [isSigningOut, setIsSigningOut] = React.useState(false);
  const { t } = useTranslation();

  /*************************************************** Functions **************************************************** */
  const logout = () => {
    setIsSigningOut(true);
    authApis
      .logout({})
      .then((response) => {
        TokenService.clearToken();
        setIsSigningOut(false);
        history.replace("/login");
      })
      .catch((error) => {
        console.log("error >>>>> ", error);
        setIsSigningOut(false);
      });
  };

  const contetnt = (
    <div className="text-align-center padding-1">
      <Avatar size={64} icon={<UserOutlined />} src={userInfo.picture} />
      <Title level={4} className="margin-top-1">
        {userInfo.name}
      </Title>
      <Text className="display-block">{userInfo.email}</Text>
      <Button
        className="sign-out-btn margin-top-1"
        onClick={logout}
        loading={isSigningOut}
      >
        {t('SIGN_OUT')}
      </Button>
    </div>
  );

  const notificationContent = (
    <List
      itemLayout="horizontal"
      dataSource={notifList}
      renderItem={(item) => (
        <List.Item>
          <List.Item.Meta
            avatar={<Avatar src={hard_drive} />}
            title={<h4>{item.name || item.deviceId}</h4>}
            description={`${item
              }`}
          />
        </List.Item>
      )}
    />
  );

  const showNotifications = () => {
    NumberOfNotifs = 0;
    setCount(NumberOfNotifs);
    setHideNotification(!hideNotification);
  };

  /*************************************************** Use Effects ************************************************** */
  React.useEffect(() => {
    if (notifications) {
      NumberOfNotifs += 1;
      setCount(NumberOfNotifs);
      notifList.unshift(notifications);
    }
  }, [notifications]);

  return (
    <Header style={{ marginBottom: '10px' }} className="header main-header-component">
      <Popover content={contetnt} trigger="click" placement="topRight">
        <Avatar
          size={"large"}
          icon={<UserOutlined />}
          src={userInfo.picture}
          className="cursor-pointer"
          alt="user"
        />
      </Popover>
      <Popover
        content={notificationContent}
        trigger="click"
        placement="topRight"
      >
        <Badge
          data-testid="badge"
          count={count}
          className="margin-start-2 cursor-pointer"
          onClick={showNotifications}
        >
          <Image src={notification} preview={false} alt="notification" />
        </Badge>
      </Popover>
    </Header>
  );
};
export default HeaderComponent;
